import MyAccountBox from "../MyAccountBox/MyAccountBox";
import LoginButton from "../LoginButton";
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Nav.module.css";
import LogoLink from "../LogoLink/LogoLink";
import NavItem from "../NavItem/NavItem";
import MyLinks from "../MyLinks/MyLinks";
import { Auth } from "../../auth";
import { useNavigate, useLocation } from "react-router-dom";
import { StaticRoutes } from "../../pages/routes";

const Nav = ({ isStatic, scrolled, navItems }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [hasToken, setHasToken] = useState(false);
  const { isLoggedIn } = Auth.useContainer();
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = useRef(null);

  const scrollToTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  useEffect(() => {
    if (isLoggedIn) {
      setHasToken(true);
    }
  }, []);

  const toggleMenu = () => {
    setMenuOpen((prevState) => !prevState);
  };

  const handleLogoClick = () => {
    if (location.pathname !== "/") {
      navigate("/");
    }
    scrollToTop();
    setMenuOpen(false);
  };

  const handleLoginClick = () => {
    navigate(StaticRoutes.Login);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={classNames(styles.nav, {
        [styles.scrolled]: !isStatic && scrolled,
        [styles.static]: isStatic,
      })}
      ref={navRef}
    >
      <div className={styles.container}>
        <LogoLink onClick={handleLogoClick} />
        <button className={styles.hamburger} onClick={toggleMenu}>
          ☰
        </button>
        <div
          className={classNames(styles.navItems, {
            [styles.navOpen]: menuOpen,
          })}
        >
          {navItems
            .filter((_, index) => !(index === navItems.length - 1 && hasToken))
            .map((item, index) => (
              <NavItem
                key={index}
                {...item}
                onClick={(path) => {
                  if (path !== location.pathname) {
                    navigate(path);
                  }
                  scrollToTop();
                  setMenuOpen(false);
                }}
              />
            ))}

          {hasToken ? (
            <>
              <div className={styles.myLinksContainer}>
                <MyLinks />
              </div>
              <div className={styles.myLinksContainer}>
                <MyAccountBox />
              </div>
            </>
          ) : (
            <>
              <LoginButton
                onBtnClick={() => {
                  handleLoginClick();
                  setMenuOpen(false);
                  scrollToTop();
                }}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

Nav.propTypes = {
  isStatic: PropTypes.bool.isRequired,
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          onClick: PropTypes.func.isRequired,
        })
      ),
      border: PropTypes.bool,
      onClick: PropTypes.func.isRequired,
    })
  ),
};

export default Nav;
